<app-sidebar></app-sidebar>
<app-header></app-header>
<div class="content-wrapper">
    <ngx-spinner type="ball-clip-rotate-multiple" [fullScreen]="true">
        <p style="color: white"> Loading... </p>
    </ngx-spinner>
    <div class="card text-center">
        <div class="col-md-12 no-print sticky">
            <div class="card">
                <div class="row justify-content-md-center" style="margin-top: 25px;">
                    <div class="col-md-auto text-left">
                        <h2>รายงาน KPI นักส่งเสริม</h2>
                    </div>
                    <div class="col-md-auto">
                        <mat-form-field appearance="fill">
                            <mat-label>เลือกงวด</mat-label>
                            <mat-select disableRipple required [(ngModel)]="selectP" (ngModelChange)="Loaddata1()">
                                <mat-option *ngFor="let item of selecttime1" [value]="item">
                                    {{item[0]}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <!--<div class="example-button-row" *ngIf="selectP.length > 0">
                            <button mat-raised-button color="primary" (click)="Loaddata1()">ตกลง</button>
                        </div>-->
                    </div>
                    <div class="col-md-auto" *ngIf="selectsup.length > 0 && dataApi0.length > 0">
                        <mat-form-field appearance="fill">
                            <mat-label>เลือกเขต/ส่วน</mat-label>
                            <mat-select disableRipple required [(ngModel)]="selectS" (ngModelChange)="filter_data()">
                                <mat-option *ngFor="let item of selectsup" [value]="item">
                                    {{item[3]}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-md-auto" *ngIf="dataApi1.length > 0">
                        <div class="button-row">
                            <span class="badge bg-warning">{{ dataApi1.length }}</span> รายการ
                            &nbsp; &nbsp;
                            <button mat-raised-button
                                *ngIf="edit_st == 0 && (userdata.userlevel == 14 || userdata.userlevel == 15)"
                                (click)="edit_st = 1">
                                <mat-icon style="color: blue;">edit</mat-icon>
                            </button>
                            <button mat-raised-button *ngIf="edit_st != 0" (click)="saveDataKpi();">
                                <mat-icon style="color: green;"> done </mat-icon>บันทึก
                            </button>
                            <button mat-raised-button *ngIf="edit_st != 0" (click)="edit_st = 0">
                                <mat-icon style="color: red;"> close </mat-icon>ยกเลิก
                            </button>
                        </div>
                        <!--<label> {{edit_st}} </label> *ngIf="dataApi1.length > 0 && edit_st == 0" -->
                    </div>
                    <div class="col-md-auto" *ngIf="dataApi1.length > 0">
                        <div class="button-row">
                            <button mat-raised-button color="accent" [disabled]="edit_st != 0"
                                (click)="printPage()"><mat-icon> print
                                </mat-icon></button>
                            <button mat-raised-button color="primary" [disabled]="edit_st != 0"
                                (click)="Loaddata1()"><mat-icon> update
                                </mat-icon></button>
                        </div>
                    </div>

                </div>
                <div class="text-center" *ngIf="dataApi1.length > 0">
                    <div class="btn-group mr-2" role="group" aria-label="Basic example" *ngFor="let sv of sum_sv">
                        <button type="button" class="btn btn-outline-danger btn-sm" id="S{{sv}}"
                            (click)="scrollTo(sv)">{{sv}}</button>
                    </div>

                </div>
            </div>
        </div>
        <div *ngIf="type_s==1">
            <div class="card" style="page-break-inside: avoid;" *ngFor="let dt of dataApi1">
                <div class="card-body">
                    <div class="text-center" id="{{dt.Supcode}}">
                        <img src="../../../../assets/images/logo-bsf.png" alt="BSF LOGO" height="55px">
                    </div>
                    <table class="table table-sm">
                        <tr>
                            <td style="width:50%;text-align:left;">
                                <label style="font-size:18px"> รายงาน KPI นักส่งเสริม {{selectP[0]}}
                                </label>
                            </td>
                            <td rowspan="2" style="width:50%;text-align:right;">
                                <label style="font-size:16px"> วันที่อัพเดตข้อมูล
                                    {{THtoLocalstring(dt.DateEdit)+'น.'}} </label>
                            </td>
                        </tr>
                        <tr>
                            <td style="text-align:left;">
                                <label style="font-size:16px">[ ส่วน: {{dt.Partcode}},
                                    เขต: {{dt.Supzone}}, รหัส: {{dt.Supcode}}, ชื่อ: {{dt.SUPNAME}} ]</label>
                            </td>
                        </tr>
                    </table>
                    <table class="table table-sm table-bordered table-head-fixed" style="width:100%;">
                        <thead style="align-content: center;">
                            <tr class="headText" style="text-shadow: 1px 1px 3px red;">
                                <td rowspan="2" colspan="2" style="width:3%"><b>No</b></td>
                                <td rowspan="2" colspan="2">
                                    <b> หัวข้อ KPI นักส่งเสริม รหัส [{{dt.Supcode}}] </b>
                                </td>
                                <td rowspan="2" colspan="2" style="width:7%"><b>เป้าหมาย</b></td>
                                <td rowspan="2" colspan="2" style="width:7%"><b>ผลงานสะสม</b></td>
                                <td rowspan="2" colspan="2" style="width:7%"><b>เป้ารายเดือน</b></td>
                                <td rowspan="2" colspan="2" style="width:7%"><b>เป้างวด</b></td>
                                <td rowspan="2" colspan="2" style="width:7%"><b>ทำได้</b></td>
                                <td rowspan="2" style="width:4%"><b>%</b></td>
                                <td rowspan="2" style="width:5%"><b>ตัวถ่วง1</b></td>
                                <td rowspan="2" style="width:5%"><b>คะแนน1</b></td>
                                <td rowspan="2" style="width:5%"><b>ตัวถ่วง2</b></td>
                            </tr>
                        </thead>
                        <tbody style="align-content: center;" [ngSwitch]="edit_st">
                            <tr class="table-success" style="text-align:center">
                                <td colspan="2"><b>1.</b></td>
                                <td colspan="16" style="text-align:left"><b>A area (พื้นที่) ไร่</b></td>
                            </tr>
                            <tr style="text-align:center">
                                <td class="row_num" colspan="2"><u></u></td>
                                <td colspan="2" style="text-align:left">1. ปริมาณตันรวม
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget01" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget01 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.s_Success01" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.s_Success01 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget01" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget01 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0" [(ngModel)]="dt.Target1"
                                        (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target1 | number:'1.0-1' }}</div>
                                </td>

                                <td colspan="2">{{dt.Success1 | number:'1.0-1'}}</td>
                                <td>{{(dt.Success1/dt.Target1)*100 | number:'1.0-1'}}</td>
                                <td>{{dt.Barrier11 | number:'1.0-1'}}</td>
                                <td>{{dt.score1 | number:'1.0-1'}}</td>
                                <td rowspan="10">{{dt.Barrier21 | number:'1.0-1'}}</td>
                            </tr>
                            <tr style="text-align:center">
                                <td class="row_num" colspan="2"><u></u></td>
                                <td colspan="2" style="text-align:left">1.1 ปริมาณตันอ้อยปลายฝน</td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget02" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget02 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.s_Success02" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.s_Success02 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget02" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget02 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0" [(ngModel)]="dt.Target2"
                                        (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target2 | number:'1.0-1'}}</div>
                                </td>
                                <td colspan="2">{{dt.Success2 | number:'1.0-1'}}</td>
                                <td>{{(dt.Success2/dt.Target2)*100 | number:'1.0-1'}}</td>
                                <td>{{dt.Barrier12 | number:'1.0-1'}}</td>
                                <td>{{dt.score2 | number:'1.0-1'}}</td>
                            </tr>

                            <tr style="text-align:center">
                                <td class="row_num" colspan="2"><u></u></td>
                                <td colspan="2" style="text-align:left">1.2 ปริมาณตันอ้อยตอ</td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget03" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget03 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.s_Success03" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.s_Success03 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget03" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget03 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2"><input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0" [(ngModel)]="dt.Target3"
                                        (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target3 | number:'1.0-1'}}</div>
                                </td>

                                <td colspan="2">{{dt.Success3 | number:'1.0-1'}}</td>
                                <td>{{(dt.Success3/dt.Target3)*100 | number:'1.0-1'}}</td>
                                <td>{{dt.Barrier13 | number:'1.0-1'}}</td>
                                <td>{{dt.score3 | number:'1.0-1'}}</td>
                            </tr>

                            <tr style="text-align:center">
                                <td class="row_num" colspan="2"><u></u></td>
                                <td colspan="2" style="text-align:left">2. พื้นที่ปลูกเสร็จรวม</td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget04" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget04 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.s_Success04" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.s_Success04 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget04" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget04 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2"><input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0" [(ngModel)]="dt.Target4"
                                        (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target4 | number:'1.0-1'}}</div>
                                </td>
                                <td colspan="2">{{dt.Success4 | number:'1.0-1'}}</td>
                                <td>{{(dt.Success4/dt.Target4)*100 | number:'1.0-1'}} </td>
                                <td>{{dt.Barrier14 | number:'1.0-1'}}</td>
                                <td>{{dt.score4 | number:'1.0-1'}}</td>

                            <tr style="text-align:center">
                                <td class="row_num" colspan="2"><u></u></td>
                                <td colspan="2" style="text-align:left">2.1 พื้นที่ปลูกเสร็จปลายฝนขยาย </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget05" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget05 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.s_Success05" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.s_Success05 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget05" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget05 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2"><input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0" [(ngModel)]="dt.Target5"
                                        (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target5 | number:'1.0-1'}}</div>
                                </td>
                                <td colspan="2">{{dt.Success5 | number:'1.0-1'}}</td>
                                <td>{{(dt.Success5/dt.Target5)*100 | number:'1.0-1'}} </td>
                                <td>{{dt.Barrier15 | number:'1.0-1'}}</td>
                                <td>{{dt.score5 | number:'1.0-1'}}</td>
                            </tr>
                            <tr style="text-align:center">
                                <td class="row_num" colspan="2"><u></u></td>
                                <td colspan="2" style="text-align:left">2.2 พื้นที่ปลูกเสร็จปลายฝนรื้อตอ </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget06" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget06 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.s_Success06" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.s_Success06 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget06" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget06 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2"><input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0" [(ngModel)]="dt.Target6"
                                        (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target6 | number:'1.0-1'}}</div>
                                </td>
                                <td colspan="2">{{dt.Success6 | number:'1.0-1'}}</td>
                                <td>{{(dt.Success6/dt.Target6)*100 | number:'1.0-1'}}</td>
                                <td>{{dt.Barrier16 | number:'1.0-1'}}</td>
                                <td>{{dt.score6 | number:'1.0-1'}}</td>
                            </tr>
                            <tr style="text-align:center">
                                <td class="row_num" colspan="2"><u></u></td>
                                <td colspan="2" style="text-align:left">2.3 พื้นที่ปลูกเสร็จอ้อยตอ </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget07" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget07 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.s_Success07" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.s_Success07 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget07" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget07 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2"><input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0" [(ngModel)]="dt.Target7"
                                        (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target7 | number:'1.0-1'}}</div>
                                </td>
                                <td colspan="2">{{dt.Success7 | number:'1.0-1'}}</td>
                                <td>{{(dt.Success7/dt.Target7)*100 | number:'1.0-1'}}</td>
                                <td>{{dt.Barrier17 | number:'1.0-1'}}</td>
                                <td>{{dt.score7 | number:'1.0-1'}}</td>
                            </tr>
                            <tr style="text-align:center">
                                <td class="row_num" colspan="2"><u></u></td>
                                <td colspan="2" style="text-align:left">2.4 พื้นที่ส่วนเพิ่ม อ้อยปลายฝน</td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget08" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget08 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.s_Success08" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.s_Success08 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget08" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget08 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2"><input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0" [(ngModel)]="dt.Target8"
                                        (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target8 | number:'1.0-1'}}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success8" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success8 | number:'1.0-1'}}</div>
                                </td>
                                <td>{{(dt.Success8/dt.Target8)*100 | number:'1.0-1'}}</td>
                                <td>{{dt.Barrier18 | number:'1.0-1'}}</td>
                                <td>{{dt.score8 | number:'1.0-1'}}</td>
                            </tr>
                            <tr style="text-align:center">
                                <td class="row_num" colspan="2"><u></u></td>
                                <td colspan="2" style="text-align:left">2.4.1 พื้นที่ปลายขยาย </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget09" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget09 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.s_Success09" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.s_Success09 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget09" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget09 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0" [(ngModel)]="dt.Target9"
                                        (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target9 | number:'1.0-1'}}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success9" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success9 | number:'1.0-1'}}</div>
                                <td>{{(dt.Success9/dt.Target9)*100 | number:'1.0-1'}}</td>
                                <td>{{dt.Barrier19 | number:'1.0-1'}}</td>
                                <td>{{dt.score9 | number:'1.0-1'}}</td>
                            </tr>
                            <tr style="text-align:center">
                                <td class="row_num" colspan="2"><u></u></td>
                                <td colspan="2" style="text-align:left">2.4.2 พื้นที่ปลายฝน (รื้อตอคงเหลือ) </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget10" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget10 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.s_Success10" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.s_Success10 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget10" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget10 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target10" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target10 | number:'1.0-1'}}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success10" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success10 | number:'1.0-1'}}</div>
                                </td>
                                <td>{{(dt.Success10/dt.Target10)*100 | number:'1.0-1'}}</td>
                                <td>{{dt.Barrier110 | number:'1.0-1'}}</td>
                                <td>{{dt.score10 | number:'1.0-1'}}</td>
                            </tr>


                            <tr class="table-secondary" style="text-align:center">
                                <td class="bg-light"></td>
                                <td colspan="3"><b>รวมข้อ 1</b></td>
                                <td colspan="2"></td>
                                <td colspan="2"></td>
                                <td colspan="2"></td>
                                <td colspan="2"></td>
                                <td colspan="3"></td>
                                <td><b>{{dt.sumbarrier1 | number:'1.0-1'}}</b></td>
                                <td><b>{{dt.scoresum1 | number:'1.0-1'}}</b></td>
                                <td><b>{{dt.score1get | number:'1.0-1'}}</b></td>
                            </tr>

                            <tr class="table-success" style="text-align:center">
                                <td colspan="2"><b>2.</b></td>
                                <td style="text-align:left"><b>B BRR MODEL (7ข้อ)</b></td>
                                <td>เกรดชาวไร่</td>
                                <td>ER</td>
                                <td>ST</td>
                                <td>ER</td>
                                <td>ST</td>
                                <td>ER</td>
                                <td>ST</td>
                                <td>ER</td>
                                <td>ST</td>
                                <td>ER</td>
                                <td>ST</td>
                                <td colspan="4"></td>
                            </tr>
                            <tr style="text-align:center">
                                <td class="row_num" colspan="2" rowspan="5"><u></u></td>
                                <td rowspan="5" style="text-align:left">1. ปรับพื้นที่เพื่อระบายน้ำ <br>
                                    <i class="sub_p">จัดการพื้นที่ให้ราบเรียบสามารถระบายน้ำได้ดีทำให้อ้อยเจริญเติบโตสม่ำเสมอทั่วทั้งแปลง
                                        ไม่ให้เกิดพื้นที่สูญเสีย</i>
                                </td>
                                <td>A</td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget01er[0]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget01er[0] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget01st[0]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget01st[0] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.sSuccess01er[0]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sSuccess01er[0] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.sSuccess01st[0]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sSuccess01st[0] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget01er[0]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget01er[0] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget01st[0]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget01st[0] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target01er[0]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target01er[0] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target01st[0]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target01st[0] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success01er[0]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success01er[0] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success01st[0]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success01st[0] | number:'1.0-1'}}</div>
                                </td>
                                <td>{{((dt.Success01er[0]+dt.Success01st[0])/
                                    (dt.Target01er[0]+dt.Target01st[0]))*100 |number:'1.0-1'}}
                                </td>
                                <td>{{dt.sBarrier11[0] | number:'1.0-1'}}</td>
                                <td>{{dt.score01et[0] | number:'1.0-1'}}</td>
                                <td rowspan="33">{{dt.Barrier22 | number:'1.0-1'}}</td>
                            </tr>
                            <tr style="text-align:center">
                                <td>B</td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget01er[1]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget01er[1] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget01st[1]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget01st[1] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.sSuccess01er[1]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sSuccess01er[1] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.sSuccess01st[1]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sSuccess01st[1] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget01er[1]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget01er[1] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget01st[1]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget01st[1] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target01er[1]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target01er[1] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target01st[1]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target01st[1] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success01er[1]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success01er[1] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success01st[1]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success01st[1] | number:'1.0-1'}}</div>
                                </td>
                                <td>{{((dt.Success01er[1]+dt.Success01st[1])/
                                    (dt.Target01er[1]+dt.Target01st[1]))*100 |
                                    number:'1.0-1'}}
                                </td>
                                <td>{{dt.sBarrier11[1] | number:'1.0-1'}}</td>
                                <td>{{dt.score01et[1] | number:'1.0-1'}}</td>
                            </tr>
                            <tr style="text-align:center">
                                <td>C</td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget01er[2]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget01er[2] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget01st[2]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget01st[2] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.sSuccess01er[2]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sSuccess01er[2] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.sSuccess01st[2]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sSuccess01st[2] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget01er[2]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget01er[2] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget01st[2]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget01st[2] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target01er[2]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target01er[2] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target01st[2]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target01st[2] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success01er[2]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success01er[2] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success01st[2]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success01st[2] | number:'1.0-1'}}</div>
                                </td>
                                <td>{{((dt.Success01er[2]+dt.Success01st[2])/
                                    (dt.Target01er[2]+dt.Target01st[2]))*100 |number:'1.0-1'}}
                                </td>
                                <td>{{dt.sBarrier11[2] | number:'1.0-1'}}</td>
                                <td>{{dt.score01et[2] | number:'1.0-1'}}</td>
                            </tr>
                            <tr style="text-align:center">
                                <td>D</td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget01er[3]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget01er[3] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget01st[3]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget01st[3] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.sSuccess01er[3]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sSuccess01er[3] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.sSuccess01st[3]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sSuccess01st[3] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget01er[3]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget01er[3] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget01st[3]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget01st[3] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target01er[3]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target01er[3] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target01st[3]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target01st[3] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success01er[3]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success01er[3] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success01st[3]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success01st[3] | number:'1.0-1'}}</div>
                                </td>
                                <td>{{((dt.Success01er[3]+dt.Success01st[3])/
                                    (dt.Target01er[3]+dt.Target01st[3]))*100 |number:'1.0-1'}}
                                </td>
                                <td>{{dt.sBarrier11[3] | number:'1.0-1'}}</td>
                                <td>{{dt.score01et[3] | number:'1.0-1'}}</td>
                            </tr>
                            <tr style="text-align:center">
                                <td>F</td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget01er[4]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget01er[4] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget01st[4]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget01st[4] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.sSuccess01er[4]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sSuccess01er[4] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.sSuccess01st[4]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sSuccess01st[4] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget01er[4]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget01er[4] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget01st[4]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget01st[4] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target01er[4]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target01er[4] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target01st[4]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target01st[4] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success01er[4]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success01er[4] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success01st[4]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success01st[4] | number:'1.0-1'}}</div>
                                </td>
                                <td>{{((dt.Success01er[4]+dt.Success01st[4])/
                                    (dt.Target01er[4]+dt.Target01st[4]))*100 |number:'1.0-1'}}
                                </td>
                                <td>{{dt.sBarrier11[4] | number:'1.0-1'}}</td>
                                <td>{{dt.score01et[4] | number:'1.0-1'}}</td>
                            </tr>

                            <tr style="text-align:center">
                                <td class="row_num" colspan="2" rowspan="5"><u></u></td>
                                <td rowspan="5" style="text-align:left">2. ระเบิดดินดาน <br>
                                    <i class="sub_p">1.เพิ่มอากาศ 2.เก็บน้ำในชั้นดิน ที่ระดับชั้นดินดานลึก >40
                                        เซนติเมตร</i>
                                </td>
                                <td>A</td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget02er[0]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget02er[0] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget02st[0]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget02st[0] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.sSuccess02er[0]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sSuccess02er[0] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.sSuccess02st[0]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sSuccess02st[0] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget02er[0]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget02er[0] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget02st[0]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget02st[0] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target02er[0]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target02er[0] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target02st[0]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target02st[0] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success02er[0]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success02er[0] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success02st[0]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success02st[0] | number:'1.0-1'}}</div>
                                </td>
                                <td>{{((dt.Success02er[0]+dt.Success02st[0])/
                                    (dt.Target02er[0]+dt.Target02st[0]))*100 |number:'1.0-1'}}
                                </td>
                                <td>{{dt.sBarrier12[0] | number:'1.0-1'}}</td>
                                <td>{{dt.score02et[0] | number:'1.0-1'}}</td>
                            </tr>
                            <tr style="text-align:center">
                                <td>B</td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget02er[1]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget02er[1] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget02st[1]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget02st[1] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.sSuccess02er[1]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sSuccess02er[1] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.sSuccess02st[1]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sSuccess02st[1] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget02er[1]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget02er[1] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget02st[1]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget02st[1] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target02er[1]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target02er[1] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target02st[1]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target02st[1] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success02er[1]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success02er[1] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success02st[1]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success02st[1] | number:'1.0-1'}}</div>
                                </td>
                                <td>{{((dt.Success02er[1]+dt.Success02st[1])/
                                    (dt.Target02er[1]+dt.Target02st[1]))*100 |number:'1.0-1'}}
                                </td>
                                <td>{{dt.sBarrier12[1] | number:'1.0-1'}}</td>
                                <td>{{dt.score02et[1] | number:'1.0-1'}}</td>
                            </tr>
                            <tr style="text-align:center">
                                <td>C</td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget02er[2]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget02er[2] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget02st[2]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget02st[2] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.sSuccess02er[2]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sSuccess02er[2] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.sSuccess02st[2]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sSuccess02st[2] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget02er[2]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget02er[2] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget02st[2]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget02st[2] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target02er[2]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target02er[2] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target02st[2]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target02st[2] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success02er[2]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success02er[2] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success02st[2]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success02st[2] | number:'1.0-1'}}</div>
                                </td>
                                <td>{{((dt.Success02er[2]+dt.Success02st[2])/
                                    (dt.Target02er[2]+dt.Target02st[2]))*100 |number:'1.0-1'}}
                                </td>
                                <td>{{dt.sBarrier12[2] | number:'1.0-1'}}</td>
                                <td>{{dt.score02et[3] | number:'1.0-1'}}</td>
                            </tr>
                            <tr style="text-align:center">
                                <td>D</td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget02er[3]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget02er[3] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget02st[3]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget02st[3] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.sSuccess02er[3]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sSuccess02er[3] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.sSuccess02st[3]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sSuccess02st[3] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget02er[3]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget02er[3] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget02st[3]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget02st[3] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target02er[3]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target02er[3] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target02st[3]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target02st[3] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success02er[3]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success02er[3] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success02st[3]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success02st[3] | number:'1.0-1'}}</div>
                                </td>
                                <td>{{((dt.Success02er[3]+dt.Success02st[3])/
                                    (dt.Target02er[3]+dt.Target02st[3]))*100 |number:'1.0-1'}}
                                </td>
                                <td>{{dt.sBarrier12[3] | number:'1.0-1'}}</td>
                                <td>{{dt.score02et[4] | number:'1.0-1'}}</td>
                            </tr>
                            <tr style="text-align:center">
                                <td>F</td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget02er[4]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget02er[4] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget02st[4]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget02st[4] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.sSuccess02er[4]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sSuccess02er[4] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.sSuccess02st[4]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sSuccess02st[4] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget02er[4]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget02er[4] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget02st[4]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget02st[4] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target02er[4]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target02er[4] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target02st[4]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target02st[4] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success02er[4]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success02er[4] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success02st[4]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success02st[4] | number:'1.0-1'}}</div>
                                </td>
                                <td>{{((dt.Success02er[4]+dt.Success02st[4])/
                                    (dt.Target02er[4]+dt.Target02st[4]))*100 |number:'1.0-1'}}
                                </td>
                                <td>{{dt.sBarrier12[4] | number:'1.0-1'}}</td>
                                <td>{{dt.score02et[4] | number:'1.0-1'}}</td>
                            </tr>

                            <tr style="text-align:center">
                                <td class="row_num" colspan="2"><u></u></td>
                                <td style="text-align:left">3. ปลูกระยะร่อง 1.60 เมตร <br>
                                    <i class="sub_p">ทำให้ใบอ้อยได้รับแสงแดดทุกใบสังเคราะห์แสงได้ดี
                                        ลมอากาศถ่ายเทได้ดี</i>
                                </td>
                            </tr>
                            <tr style="text-align:center">
                                <td class="row_num" colspan="2" rowspan="5"><u></u></td>
                                <td rowspan="5" style="text-align:left">4. อิทธิพลการใช้พันธุ์อ้อยแปลงพันธุ์สะอาด <br>
                                    <i class="sub_p">ทำให้ผลผลิตอ้อยสูง ลดการเกิดโรคที่มาจากท่อนพันธุ์ %การงอกดี</i>
                                </td>
                                <td>A</td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget04er[0]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget04er[0] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget04st[0]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget04st[0] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.sSuccess04er[0]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sSuccess04er[0] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.sSuccess04st[0]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sSuccess04st[0] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget04er[0]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget04er[0] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget04st[0]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget04st[0] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target04er[0]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target04er[0] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target04st[0]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target04st[0] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success04er[0]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success04er[0] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success04st[0]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success04st[0] | number:'1.0-1'}}</div>
                                </td>
                                <td>{{((dt.Success04er[0]+dt.Success04st[0])/
                                    (dt.Target04er[0]+dt.Target04st[0]))*100 |number:'1.0-1'}}
                                </td>
                                <td>{{dt.sBarrier14[0] | number:'1.0-1'}}</td>
                                <td>{{dt.score04et[0] | number:'1.0-1'}}</td>
                            </tr>
                            <tr style="text-align:center">
                                <td>B</td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget04er[1]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget04er[1] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget04st[1]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget04st[1] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.sSuccess04er[1]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sSuccess04er[1] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.sSuccess04st[1]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sSuccess04st[1] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget04er[1]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget04er[1] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget04st[1]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget04st[1] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target04er[1]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target04er[1] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target04st[1]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target04st[1] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success04er[1]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success04er[1] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success04st[1]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success04st[1] | number:'1.0-1'}}</div>
                                </td>
                                <td>{{((dt.Success04er[1]+dt.Success04st[1])/
                                    (dt.Target04er[1]+dt.Target04st[1]))*100 |number:'1.0-1'}}
                                </td>
                                <td>{{dt.sBarrier14[1] | number:'1.0-1'}}</td>
                                <td>{{dt.score04et[1] | number:'1.0-1'}}</td>
                            </tr>
                            <tr style="text-align:center">
                                <td>C</td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget04er[2]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget04er[2] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget04st[2]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget04st[2] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.sSuccess04er[2]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sSuccess04er[2] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.sSuccess04st[2]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sSuccess04st[2] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget04er[2]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget04er[2] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget04st[2]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget04st[2] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target04er[2]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target04er[2] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target04st[2]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target04st[2] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success04er[2]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success04er[2] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success04st[2]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success04st[2] | number:'1.0-1'}}</div>
                                </td>
                                <td>{{((dt.Success04er[2]+dt.Success04st[2])/
                                    (dt.Target04er[2]+dt.Target04st[2]))*100 |number:'1.0-1'}}
                                </td>
                                <td>{{dt.sBarrier14[2] | number:'1.0-1'}}</td>
                                <td>{{dt.score02et[2] | number:'1.0-1'}}</td>
                            </tr>
                            <tr style="text-align:center">
                                <td>D</td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget04er[3]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget04er[3] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget04st[3]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget04st[3] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.sSuccess04er[3]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sSuccess04er[3] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.sSuccess04st[3]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sSuccess04st[3] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget04er[3]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget04er[3] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget04st[3]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget04st[3] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target04er[3]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target04er[3] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target04st[3]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target04st[3] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success04er[3]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success04er[3] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success04st[3]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success04st[3] | number:'1.0-1'}}</div>
                                </td>
                                <td>{{((dt.Success04er[3]+dt.Success04st[3])/
                                    (dt.Target04er[3]+dt.Target04st[3]))*100 |number:'1.0-1'}}
                                </td>
                                <td>{{dt.sBarrier14[3] | number:'1.0-1'}}</td>
                                <td>{{dt.score04et[3] | number:'1.0-1'}}</td>
                            </tr>
                            <tr style="text-align:center">
                                <td>F</td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget04er[4]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget04er[4] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget04st[4]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget04st[4] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.sSuccess04er[4]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sSuccess04er[4] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.sSuccess04st[4]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sSuccess04st[4] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget04er[4]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget04er[4] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget04st[4]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget04st[4] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target04er[4]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target04er[4] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target04st[4]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target04st[4] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success04er[4]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success04er[4] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success04st[4]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success04st[4] | number:'1.0-1'}}</div>
                                </td>
                                <td>{{((dt.Success04er[4]+dt.Success04st[4])/
                                    (dt.Target04er[4]+dt.Target04st[4]))*100 |number:'1.0-1'}}
                                </td>
                                <td>{{dt.sBarrier14[4] | number:'1.0-1'}}</td>
                                <td>{{dt.score04et[4] | number:'1.0-1'}}</td>
                            </tr>
                            <tr style="text-align:center">
                                <td class="row_num" colspan="2" rowspan="5"><u></u></td>
                                <td rowspan="5" style="text-align:left">5. ใส่โดโลไมท์ <br>
                                    <i class="sub_p">เพิ่มธาตุแคลเซียมทำให้อ้อยแข็งแรงเจริญเติบโตได้ดี
                                        ธาตุแมกนีเซียมเพิ่มกระบวนการสังเคราะห์แสง ช่วยเพิ่มผลผลิต</i>
                                </td>
                                <td>A</td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget05er[0]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget05er[0] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget05st[0]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget05st[0] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.sSuccess05er[0]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sSuccess05er[0] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.sSuccess05st[0]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sSuccess05st[0] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget05er[0]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget05er[0] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget05st[0]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget05st[0] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target05er[0]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target05er[0] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target05st[0]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target05st[0] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success05er[0]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success05er[0] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success05st[0]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success05st[0] | number:'1.0-1'}}</div>
                                </td>
                                <td>{{((dt.Success05er[0]+dt.Success05st[0])/
                                    (dt.Target05er[0]+dt.Target05st[0]))*100 |number:'1.0-1'}}
                                </td>
                                <td>{{dt.sBarrier15[0] | number:'1.0-1'}}</td>
                                <td>{{dt.score05et[0] | number:'1.0-1'}}</td>
                            </tr>
                            <tr style="text-align:center">
                                <td>B</td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget05er[1]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget05er[1] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget05st[1]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget05st[1] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.sSuccess05er[1]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sSuccess05er[1] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.sSuccess05st[1]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sSuccess05st[1] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget05er[1]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget05er[1] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget05st[1]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget05st[1] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target05er[1]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target05er[1] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target05st[1]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target05st[1] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success05er[1]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success05er[1] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success05st[1]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success05st[1] | number:'1.0-1'}}</div>
                                </td>
                                <td>{{((dt.Success05er[1]+dt.Success05st[1])/
                                    (dt.Target05er[1]+dt.Target05st[1]))*100 |number:'1.0-1'}}
                                </td>
                                <td>{{dt.sBarrier15[1] | number:'1.0-1'}}</td>
                                <td>{{dt.score05et[1] | number:'1.0-1'}}</td>
                            </tr>
                            <tr style="text-align:center">
                                <td>C</td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget05er[2]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget05er[2] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget05st[2]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget05st[2] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.sSuccess05er[2]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sSuccess05er[2] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.sSuccess05st[2]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sSuccess05st[2] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget05er[2]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget05er[2] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget05st[2]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget05st[2] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target05er[2]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target05er[2] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target05st[2]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target05st[2] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success05er[2]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success05er[2] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success05st[2]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success05st[2] | number:'1.0-1'}}</div>
                                </td>
                                <td>{{((dt.Success05er[2]+dt.Success05st[2])/
                                    (dt.Target05er[2]+dt.Target05st[2]))*100 |number:'1.0-1'}}
                                </td>
                                <td>{{dt.sBarrier15[2] | number:'1.0-1'}}</td>
                                <td>{{dt.score05et[2] | number:'1.0-1'}}</td>
                            </tr>
                            <tr style="text-align:center">
                                <td>D</td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget05er[3]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget05er[3] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget05st[3]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget05st[3] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.sSuccess05er[3]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sSuccess05er[3] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.sSuccess05st[3]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sSuccess05st[3] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget05er[3]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget05er[3] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget05st[3]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget05st[3] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target05er[3]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target05er[3] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target05st[3]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target05st[3] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success05er[3]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success05er[3] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success05st[3]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success05st[3] | number:'1.0-1'}}</div>
                                </td>
                                <td>{{((dt.Success05er[3]+dt.Success05st[3])/
                                    (dt.Target05er[3]+dt.Target05st[3]))*100 |number:'1.0-1'}}
                                </td>
                                <td>{{dt.sBarrier15[3] | number:'1.0-1'}}</td>
                                <td>{{dt.score05et[3] | number:'1.0-1'}}</td>
                            </tr>
                            <tr style="text-align:center">
                                <td>F</td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget05er[4]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget05er[4] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget05st[4]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget05st[4] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.sSuccess05er[4]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sSuccess05er[4] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.sSuccess05st[4]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sSuccess05st[4] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget05er[4]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget05er[4] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget05st[4]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget05st[4] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target05er[4]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target05er[4] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target05st[4]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target05st[4] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success05er[4]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success05er[4] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success05st[4]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success05st[4] | number:'1.0-1'}}</div>
                                </td>
                                <td>{{((dt.Success05er[4]+dt.Success05st[4])/
                                    (dt.Target05er[4]+dt.Target05st[4]))*100 |number:'1.0-1'}}
                                </td>
                                <td>{{dt.sBarrier15[4] | number:'1.0-1'}}</td>
                                <td>{{dt.score05et[4] | number:'1.0-1'}}</td>
                            </tr>

                            <tr style="text-align:center">
                                <td class="row_num" colspan="2" rowspan="5"><u></u></td>
                                <td rowspan="5" style="text-align:left">6. ใส่ปุ๋ยอินทรีย์ <br>
                                    <i class="sub_p">ทำให้ดินมีชีวิต เพิ่มจุลินทรีย์ที่เป็นประโยชน์ในดิน
                                        เพิ่มประสิทธิภาพการใช้ปุ๋ยเคมี</i>
                                </td>
                                <td>A</td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget06er[0]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget06er[0] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget06st[0]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget06st[0] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.sSuccess06er[0]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sSuccess06er[0] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.sSuccess06st[0]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sSuccess06st[0] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget06er[0]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget06er[0] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget06st[0]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget06st[0] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target06er[0]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target06er[0] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target06st[0]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target06st[0] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success06er[0]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success06er[0] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success06st[0]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success06st[0] | number:'1.0-1'}}</div>
                                </td>
                                <td>{{((dt.Success06er[0]+dt.Success06st[0])/
                                    (dt.Target06er[0]+dt.Target06st[0]))*100 |number:'1.0-1'}}
                                </td>
                                <td>{{dt.sBarrier16[0] | number:'1.0-1'}}</td>
                                <td>{{dt.score07et[0] | number:'1.0-1'}}</td>
                            </tr>
                            <tr style="text-align:center">
                                <td>B</td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget06er[1]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget06er[1] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget06st[1]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget06st[1] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.sSuccess06er[1]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sSuccess06er[1] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.sSuccess06st[1]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sSuccess06st[1] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget06er[1]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget06er[1] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget06st[1]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget06st[1] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target06er[1]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target06er[1] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target06st[1]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target06st[1] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success06er[1]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success06er[1] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success06st[1]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success06st[1] | number:'1.0-1'}}</div>
                                </td>
                                <td>{{((dt.Success06er[1]+dt.Success06st[1])/
                                    (dt.Target06er[1]+dt.Target06st[1]))*100 |number:'1.0-1'}}
                                </td>
                                <td>{{dt.sBarrier16[1] | number:'1.0-1'}}</td>
                                <td>{{dt.score06et[1] | number:'1.0-1'}}</td>
                            </tr>
                            <tr style="text-align:center">
                                <td>C</td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget06er[2]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget06er[2] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget06st[2]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget06st[2] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.sSuccess06er[2]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sSuccess06er[2] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.sSuccess06st[2]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sSuccess06st[2] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget06er[2]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget06er[2] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget06st[2]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget06st[2] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target06er[2]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target06er[2] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target06st[2]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target06st[2] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success06er[2]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success06er[2] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success06st[2]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success06st[2] | number:'1.0-1'}}</div>
                                </td>
                                <td>{{((dt.Success06er[2]+dt.Success06st[2])/
                                    (dt.Target06er[2]+dt.Target06st[2]))*100 |number:'1.0-1'}}
                                </td>
                                <td>{{dt.sBarrier16[2] | number:'1.0-1'}}</td>
                                <td>{{dt.score06et[2] | number:'1.0-1'}}</td>
                            </tr>
                            <tr style="text-align:center">
                                <td>D</td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget06er[3]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget06er[3] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget06st[3]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget06st[3] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.sSuccess06er[3]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sSuccess06er[3] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.sSuccess06st[3]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sSuccess06st[3] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget06er[3]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget06er[3] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget06st[3]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget06st[3] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target06er[3]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target06er[3] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target06st[3]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target06st[3] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success06er[3]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success06er[3] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success06st[3]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success06st[3] | number:'1.0-1'}}</div>
                                </td>
                                <td>{{((dt.Success06er[3]+dt.Success06st[3])/
                                    (dt.Target06er[3]+dt.Target06st[3]))*100 |number:'1.0-1'}}
                                </td>
                                <td>{{dt.sBarrier16[3] | number:'1.0-1'}}</td>
                                <td>{{dt.score06et[3] | number:'1.0-1'}}</td>
                            </tr>
                            <tr style="text-align:center">
                                <td>F</td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget06er[4]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget06er[4] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget06st[4]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget06st[4] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.sSuccess06er[4]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sSuccess06er[4] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.sSuccess06st[4]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sSuccess06st[4] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget06er[4]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget06er[4] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget06st[4]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget06st[4] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target06er[4]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target06er[4] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target06st[4]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target06st[4] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success06er[4]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success06er[4] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success06st[4]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success06st[4] | number:'1.0-1'}}</div>
                                </td>
                                <td>{{((dt.Success06er[4]+dt.Success06st[4])/
                                    (dt.Target06er[4]+dt.Target06st[4]))*100 |number:'1.0-1'}}
                                </td>
                                <td>{{dt.sBarrier16[4] | number:'1.0-1'}}</td>
                                <td>{{dt.score06et[4] | number:'1.0-1'}}</td>
                            </tr>
                            <tr style="text-align:center">
                                <td class="row_num" colspan="2" rowspan="5"><u></u></td>
                                <td rowspan="5" style="text-align:left">7. ใส่ปุ๋ยเคมี <br>
                                    <i class="sub_p">ให้ปุ๋ยตรงสูตร ตรงเวลา ปริมาณเพียงพอ ต่อความต้องการของอ้อย</i>
                                </td>
                                <td>A</td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget07er[0]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget07er[0] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget07st[0]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget07st[0] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.sSuccess07er[0]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sSuccess07er[0] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.sSuccess07st[0]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sSuccess07st[0] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget07er[0]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget07er[0] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget07st[0]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget07st[0] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target07er[0]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target07er[0] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target07st[0]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target07st[0] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success07er[0]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success07er[0] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success07st[0]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success07st[0] | number:'1.0-1'}}</div>
                                </td>
                                <td>{{((dt.Success07er[0]+dt.Success07st[0])/
                                    (dt.Target07er[0]+dt.Target07st[0]))*100 |number:'1.0-1'}}
                                </td>
                                <td>{{dt.sBarrier17[0] | number:'1.0-1'}}</td>
                                <td>{{dt.score07et[0] | number:'1.0-1'}}</td>
                            </tr>
                            <tr style="text-align:center">
                                <td>B</td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget07er[1]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget07er[1] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget07st[1]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget07st[1] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.sSuccess07er[1]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sSuccess07er[1] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.sSuccess07st[1]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sSuccess07st[1] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget07er[1]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget07er[1] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget07st[1]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget07st[1] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target07er[1]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target07er[1] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target07st[1]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target07st[1] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success07er[1]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success07er[1] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success07st[1]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success07st[1] | number:'1.0-1'}}</div>
                                </td>
                                <td>{{((dt.Success07er[1]+dt.Success07st[1])/
                                    (dt.Target07er[1]+dt.Target07st[1]))*100 |number:'1.0-1'}}
                                </td>
                                <td>{{dt.sBarrier17[1] | number:'1.0-1'}}</td>
                                <td>{{dt.score07et[1] | number:'1.0-1'}}</td>
                            </tr>
                            <tr style="text-align:center">
                                <td>C</td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget07er[2]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget07er[2] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget07st[2]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget07st[2] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.sSuccess07er[2]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sSuccess07er[2] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.sSuccess07st[2]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sSuccess07st[2] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget07er[2]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget07er[2] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget07st[2]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget07st[2] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target07er[2]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target07er[2] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target07st[2]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target07st[2] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success07er[2]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success07er[2] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success07st[2]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success07st[2] | number:'1.0-1'}}</div>
                                </td>
                                <td>{{((dt.Success07er[2]+dt.Success07st[2])/
                                    (dt.Target07er[2]+dt.Target07st[2]))*100 |number:'1.0-1'}}
                                </td>
                                <td>{{dt.sBarrier17[2] | number:'1.0-1'}}</td>
                                <td>{{dt.score07et[2] | number:'1.0-1'}}</td>
                            </tr>
                            <tr style="text-align:center">
                                <td>D</td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget07er[3]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget07er[3] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget07st[3]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget07st[3] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.sSuccess07er[3]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sSuccess07er[3] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.sSuccess07st[3]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sSuccess07st[3] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget07er[3]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget07er[3] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget07st[3]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget07st[3] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target07er[3]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target07er[3] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target07st[3]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target07st[3] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success07er[3]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success07er[3] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success07st[3]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success07st[3] | number:'1.0-1'}}</div>
                                </td>
                                <td>{{((dt.Success07er[3]+dt.Success07st[3])/
                                    (dt.Target07er[3]+dt.Target07st[3]))*100 |number:'1.0-1'}}
                                </td>
                                <td>{{dt.sBarrier17[3] | number:'1.0-1'}}</td>
                                <td>{{dt.score07et[3] | number:'1.0-1'}}</td>
                            </tr>
                            <tr style="text-align:center">
                                <td>F</td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget07er[4]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget07er[4] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget07st[4]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget07st[4] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.sSuccess07er[4]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sSuccess07er[4] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.sSuccess07st[4]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sSuccess07st[4] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget07er[4]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget07er[4] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget07st[4]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget07st[4] | number:'1.0-1' }}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target07er[4]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target07er[4] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target07st[4]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target07st[4] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success07er[4]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success07er[4] | number:'1.0-1'}}</div>
                                </td>
                                <td>
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success07st[4]" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success07st[4] | number:'1.0-1'}}</div>
                                </td>
                                <td>{{((dt.Success07er[4]+dt.Success07st[4])/
                                    (dt.Target07er[4]+dt.Target07st[4]))*100 |number:'1.0-1'}}
                                </td>
                                <td>{{dt.sBarrier17[4] | number:'1.0-1'}}</td>
                                <td>{{dt.score07et[4] | number:'1.0-1'}}</td>
                            </tr>
                            <tr style="text-align:center">
                                <td class="row_num" colspan="2"><u></u></td>
                                <td colspan="2" style="text-align:left">- แปลงพันธุ์อ้อยสะอาด ประจำกลุ่ม <br>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget16" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget16 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.s_Success16" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.s_Success16 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget16" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget16 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target16" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target16 | number:'1.0-1'}}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success16" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success16 | number:'1.0-1'}}</div>
                                </td>
                                <td>{{(dt.Success16/dt.Target16)*100 | number:'1.0-1'}}</td>
                                <td>{{dt.Barrier116 | number:'1.0-1'}}</td>
                                <td>{{dt.score16 | number:'1.0-1'}}</td>
                            </tr>
                            <tr style="text-align:center">
                                <td class="row_num" colspan="2"><u></u></td>
                                <td colspan="2" style="text-align:left">- อัพเดทกิจกรรมแปลง <br>
                                </td>
                                <td colspan="2">
                                    <!--<input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget17" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget17 | number:'1.0-1' }}</div>-->
                                    <div>{{dt.sTarget17 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.s_Success17" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.s_Success17 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget17" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget17 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target17" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target17 | number:'1.0-1'}}</div>
                                </td>
                                <td colspan="2">
                                    <!--<input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success17" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success17 | number:'1.0-1'}}</div>-->
                                    <div>{{dt.Success17 | number:'1.0-1'}}</div>
                                </td>
                                <td>{{(dt.Success17/dt.Target17)*100 | number:'1.0-1'}}</td>
                                <td>{{dt.Barrier117 | number:'1.0-1'}}</td>
                                <td>{{dt.score17 | number:'1.0-1'}}</td>
                            </tr>

                            <tr class="table-secondary" style="text-align:center">
                                <td class="bg-light"></td>
                                <td colspan="3"><b>รวมข้อ 2</b></td>
                                <td colspan="2"></td>
                                <td colspan="2"></td>
                                <td colspan="2"></td>
                                <td colspan="2"></td>
                                <td colspan="3"></td>
                                <td><b>{{dt.sumbarrier2 | number:'1.0-1'}}</b></td>
                                <td><b>{{dt.scoresum2 | number:'1.0-1'}}</b></td>
                                <td><b>{{dt.score2get | number:'1.0-1'}}</b></td>
                            </tr>

                            <tr class="table-success" style="text-align:center">
                                <td colspan="2"><b>3.</b></td>
                                <td colspan="16" style="text-align:left"><b>C control (กลุ่ม,ชาวไร่,นสส,โรงงาน)</b></td>
                            </tr>
                            <tr style="text-align:center">
                                <td class="row_num" colspan="2"><u></u></td>
                                <td colspan="2" style="text-align:left">1. กลุ่มสร้างอ้อย ประชุมกลุ่ม 1ครั้ง/เดือน
                                </td>
                                <td colspan="13"></td>
                                <td rowspan="10">{{dt.Barrier23 | number:'1.0-1'}}</td>
                            </tr>
                            <tr style="text-align:center">
                                <td class="row_num" colspan="2"><u></u></td>
                                <td colspan="2" style="text-align:left">-ประชุมกลุ่มสร้างอ้อย ส่งใบตรวจกิจกรรมแปลง</td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget21" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget21 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.s_Success21" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.s_Success21 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget21" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget21 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target21" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target21 | number:'1.0-1'}}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success21" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success21 | number:'1.0-1'}}</div>
                                </td>
                                <td>{{(dt.Success21/dt.Target21)*100 | number:'1.0-1'}}
                                <td>{{dt.Barrier121 | number:'1.0-1'}}</td>
                                <td>{{dt.score21 | number:'1.0-1'}}</td>

                            </tr>
                            <tr style="text-align:center">
                                <td class="row_num" colspan="2"><u></u></td>
                                <td colspan="2" style="text-align:left">-ตรวจส่งสมุดคู่มือกลุ่มเกษตรกร</td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget22" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget22 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.s_Success22" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.s_Success22 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget22" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget22 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target22" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target22 | number:'1.0-1'}}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success22" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success22 | number:'1.0-1'}}</div>
                                </td>
                                <td>{{(dt.Success22/dt.Target22)*100 | number:'1.0-1'}}
                                <td>{{dt.Barrier122 | number:'1.0-1'}}</td>
                                <td>{{dt.score22 | number:'1.0-1'}}</td>
                            </tr>
                            <tr style="text-align:center">
                                <td class="row_num" colspan="2"><u></u></td>
                                <td colspan="2" style="text-align:left">2 ยกระดับชาวไร่ เป็นเกรด A</td>
                            </tr>
                            <tr style="text-align:center">
                                <td class="row_num" colspan="2"><u></u></td>
                                <td colspan="2" style="text-align:left">2.1 เป้าหมาย A เป็น นักส่งเสริมวิชาการของตนเอง
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget23" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget23 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.s_Success23" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.s_Success23 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget23" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget23 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target23" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target23 | number:'1.0-1'}}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success23" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success23 | number:'1.0-1'}}</div>
                                </td>
                                <td>{{(dt.Success23/dt.Target23)*100 | number:'1.0-1'}}
                                <td>{{dt.Barrier123 | number:'1.0-1'}}</td>
                                <td>{{dt.score23 | number:'1.0-1'}}</td>
                            </tr>
                            <tr style="text-align:center">
                                <td class="row_num" colspan="2"><u></u></td>
                                <td colspan="2" style="text-align:left">2.2 เป้าหมาย B เป็น A</td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget24" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget24 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.s_Success24" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.s_Success24 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget24" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget24 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target24" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target24 | number:'1.0-1'}}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success24" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success24 | number:'1.0-1'}}</div>
                                </td>
                                <td>{{(dt.Success24/dt.Target24)*100 | number:'1.0-1'}}
                                <td>{{dt.Barrier124 | number:'1.0-1'}}</td>
                                <td>{{dt.score24 | number:'1.0-1'}}</td>
                            </tr>
                            <tr style="text-align:center">
                                <td class="row_num" colspan="2"><u></u></td>
                                <td colspan="2" style="text-align:left">2.3 เป้าหมาย C เป็น A </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget25" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget25 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.s_Success25" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.s_Success25 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget25" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget25 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target25" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target25 | number:'1.0-1'}}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success25" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success25 | number:'1.0-1'}}</div>
                                </td>
                                <td>{{(dt.Success25/dt.Target25)*100 | number:'1.0-1'}}
                                <td>{{dt.Barrier125 | number:'1.0-1'}}</td>
                                <td>{{dt.score24 | number:'1.0-1'}}</td>
                            </tr>
                            <tr style="text-align:center">
                                <td class="row_num" colspan="2"><u></u></td>
                                <td colspan="2" style="text-align:left">2.4 เป้าหมาย D กลุ่มฟื้นฟู เป็น B และ A</td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget26" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget26 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.s_Success26" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.s_Success26 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget26" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget26 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target26" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target26 | number:'1.0-1'}}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success26" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success26 | number:'1.0-1'}}</div>
                                </td>
                                <td>{{(dt.Success26/dt.Target26)*100 | number:'1.0-1'}}
                                <td>{{dt.Barrier126 | number:'1.0-1'}}</td>
                                <td>{{dt.score26 | number:'1.0-1'}}</td>
                            </tr>
                            <tr style="text-align:center">
                                <td class="row_num" colspan="2"><u></u></td>
                                <td colspan="2" style="text-align:left">2.5 เป้าหมาย F กลุ่มโรคและแมลง ระบาด</td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget27" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget27 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.s_Success27" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.s_Success27 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget27" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget27 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target27" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target27 | number:'1.0-1'}}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success27" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success27 | number:'1.0-1'}}</div>
                                </td>
                                <td>{{(dt.Success27/dt.Target27)*100 | number:'1.0-1'}}
                                <td>{{dt.Barrier127 | number:'1.0-1'}}</td>
                                <td>{{dt.score27 | number:'1.0-1'}}</td>
                            </tr>
                            <tr style="text-align:center">
                                <td class="row_num" colspan="2"><u></u></td>
                                <td colspan="2" style="text-align:left">3 นสส. คะแนนสอบ ตรวจวัด/ทักษะ/ความรู้พนักงาน
                                    เป็นเกรดA</td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget28" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget28 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.s_Success28" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.s_Success28 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget28" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget28 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target28" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target28 | number:'1.0-1'}}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success28" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success28 | number:'1.0-1'}}</div>
                                </td>
                                <td>{{(dt.Success28/dt.Target28)*100 | number:'1.0-1'}}
                                <td>{{dt.Barrier128 | number:'1.0-1'}}</td>
                                <td>{{dt.score28 | number:'1.0-1'}}</td>
                            </tr>
                            <tr class="table-secondary" style="text-align:center">
                                <td class="bg-light"></td>
                                <td colspan="3"><b>รวมข้อ 3</b></td>
                                <td colspan="2"></td>
                                <td colspan="2"></td>
                                <td colspan="2"></td>
                                <td colspan="2"></td>
                                <td colspan="3"></td>
                                <td><b>{{dt.sumbarrier3 | number:'1.0-1'}}</b></td>
                                <td><b>{{dt.scoresum3 | number:'1.0-1'}}</b></td>
                                <td><b>{{dt.score3get | number:'1.0-1'}}</b></td>
                            </tr>

                            <tr class="table-success" style="text-align:center">
                                <td colspan="2" style="text-align:center"><b>4.</b></td>
                                <td colspan="16" style="text-align:left"><b>D develop (พัฒนา)</b></td>
                            </tr>
                            <tr style="text-align:center">
                                <td class="row_num" colspan="2"><u></u></td>
                                <td colspan="2" style="text-align:left">กิจกรรมพัฒนายกระดับชาวไร่ B, C, D, F เป็นเกรด A
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget31" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget31 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.s_Success31" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.s_Success31 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget31" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget31 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target31" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target31 | number:'1.0-1'}}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success31" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success31 | number:'1.0-1'}}</div>
                                </td>
                                <td>{{(dt.Success31/dt.Target31)*100 | number:'1.0-1'}}
                                <td>{{dt.Barrier131 | number:'1.0-1'}}</td>
                                <td>{{dt.score31 | number:'1.0-1'}}</td>
                                <td rowspan="3">{{dt.Barrier24 | number:'1.0-1'}}</td>
                            </tr>

                            <tr style="text-align:center">
                                <td class="row_num" colspan="2"><u></u></td>
                                <td colspan="2" style="text-align:left">
                                    -กิจกรรมพิสูจน์ทราบ/กิจกรรมดูงานแปลงสำเร็จแล้วจัดกิจกรรมฟิวเดย์ ,ประกวดอ้อย</td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget32" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget32 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.s_Success32" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.s_Success32 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget32" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget32 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target32" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target32 | number:'1.0-1'}}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success32" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success32 | number:'1.0-1'}}</div>
                                </td>
                                <td>{{(dt.Success32/dt.Target32)*100 | number:'1.0-1'}}
                                <td>{{dt.Barrier132 | number:'1.0-1'}}</td>
                                <td>{{dt.score32 | number:'1.0-1'}}</td>
                            </tr>

                            <tr style="text-align:center">
                                <td class="row_num" colspan="2"><u></u></td>
                                <td colspan="2" style="text-align:left">
                                    -ดูงานระหว่างเขต/ กลุ่ม/ นอกพื้นที่, กลุ่มแปลงใหญ่</td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget33" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget33 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.s_Success33" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.s_Success33 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget33" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget33 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target33" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target33 | number:'1.0-1'}}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success33" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success33 | number:'1.0-1'}}</div>
                                </td>
                                <td>{{(dt.Success33/dt.Target33)*100 | number:'1.0-1'}}
                                <td>{{dt.Barrier133 | number:'1.0-1'}}</td>
                                <td>{{dt.score33 | number:'1.0-1'}}</td>
                            </tr>

                            <tr class="table-secondary" style="text-align:center">
                                <td class="bg-light"></td>
                                <td colspan="3"><b>รวมข้อ 4</b></td>
                                <td colspan="2"></td>
                                <td colspan="2"></td>
                                <td colspan="2"></td>
                                <td colspan="2"></td>
                                <td colspan="3"></td>
                                <td><b>{{dt.sumbarrier4 | number:'1.0-1'}}</b></td>
                                <td><b>{{dt.scoresum4 | number:'1.0-1'}}</b></td>
                                <td><b>{{dt.score4get | number:'1.0-1'}}</b></td>
                            </tr>

                            <tr class="table-success" style="text-align:center">
                                <td colspan="2" style="text-align:center"><b>5.</b></td>
                                <td colspan="16" style="text-align:left"><b>T Team Work</b></td>
                            </tr>
                            <tr style="text-align:center">
                                <td class="row_num" colspan="2"><u></u></td>
                                <td colspan="2" style="text-align:left">การทำงานเป็นทีม
                                </td>
                                <td colspan="13"></td>
                                <td rowspan="3">{{dt.Barrier25 | number:'1.0-1'}}</td>
                            </tr>
                            <tr style="text-align:center">
                                <td class="row_num" colspan="2"><u></u></td>
                                <td colspan="2" style="text-align:left">1 คะแนนรวมเขต</td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget34" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget34 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.s_Success34" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.s_Success34 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget34" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget34 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target34" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target34 | number:'1.0-1'}}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success34" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success34 | number:'1.0-1'}}</div>
                                </td>
                                <td>{{(dt.Success34/dt.Target34)*100 | number:'1.0-1'}}
                                <td>{{dt.Barrier134 | number:'1.0-1'}}</td>
                                <td>{{dt.score34 | number:'1.0-1'}}</td>
                            </tr>
                            <tr style="text-align:center">
                                <td class="row_num" colspan="2"><u></u></td>
                                <td colspan="2" style="text-align:left">2 คะแนน นอส. </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adffb1;" min="0"
                                        [(ngModel)]="dt.sTarget35" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.sTarget35 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #acf8a5;" min="0"
                                        [(ngModel)]="dt.s_Success35" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.s_Success35 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #d4fda5;" min="0"
                                        [(ngModel)]="dt.mTarget35" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.mTarget35 | number:'1.0-1' }}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #fffcad;" min="0"
                                        [(ngModel)]="dt.Target35" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Target35 | number:'1.0-1'}}</div>
                                </td>
                                <td colspan="2">
                                    <input *ngSwitchCase="1" type="number" matInput
                                        style="text-align:center; background: #adceff;" min="0"
                                        [(ngModel)]="dt.Success35" (ngModelChange)="dt.modify = true;" />
                                    <div *ngSwitchCase="0">{{dt.Success35 | number:'1.0-1'}}</div>
                                </td>
                                <td>{{(dt.Success35/dt.Target35)*100 | number:'1.0-1'}}
                                <td>{{dt.Barrier135 | number:'1.0-1'}}</td>
                                <td>{{dt.score35 | number:'1.0-1'}}</td>
                            </tr>
                            <tr class="table-secondary" style="text-align:center">
                                <td class="bg-light"></td>
                                <td colspan="3"><b>รวมข้อ 5</b></td>
                                <td colspan="2"></td>
                                <td colspan="2"></td>
                                <td colspan="2"></td>
                                <td colspan="2"></td>
                                <td colspan="3"></td>
                                <td><b>{{dt.sumbarrier5 | number:'1.0-1'}}</b></td>
                                <td><b>{{dt.scoresum5 | number:'1.0-1'}}</b></td>
                                <td><b>{{dt.score5get | number:'1.0-1'}}</b></td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr class="table-primary under" style="text-align:center">
                                <td colspan="2">รวม</td>
                                <td colspan="14"></td>
                                <td>{{dt.sumBarrier20 | number:'1.0-1'}}</td>
                                <td>{{dt.scoretotal | number:'1.0-1'}}</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
<app-footer></app-footer>